import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { goToAppStore } from "../lib/api";

export const CtaBand = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-2xl bg-stylist-ink px-6 py-14 md:px-16 md:py-20 text-center"
        >
          <div className="absolute inset-0 ss-grain opacity-[0.06] pointer-events-none" />
          <div className="relative">
            <span className="eyebrow text-stylist-rose">Ready when you are</span>
            <h2 className="mt-4 font-serif font-light text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] max-w-2xl mx-auto">
              Ready to transform your hair?
            </h2>
            <p className="mt-5 text-white/60 max-w-xl mx-auto leading-relaxed">
              Get expert, personalised guidance in minutes, matched to your exact hair type,
              texture and goals. No salon appointment needed.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={goToAppStore}
                data-testid="cta-band-chat"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-stylist-gold text-stylist-ink px-8 py-4 text-sm font-medium hover:bg-white transition-colors duration-300"
              >
                Subscribe today
                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </button>
              <a
                href="#journal"
                data-testid="cta-band-journal"
                className="group inline-flex items-center justify-center gap-2 rounded-full border border-white/20 text-white px-8 py-4 text-sm hover:border-white hover:bg-white/5 transition-all"
              >
                Explore the Style Journal
                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
